(function () {
  'use strict';

  if (window.UnifiedDetection) {
    return;
  }

  const VERSION = '1.1.0';

  /*
   * ------------------------------------------------------------
   * HELPERS
   * ------------------------------------------------------------
   */

  function getConfig() {
    return (
      window.UnifiedTrackingConfig ||
      {}
    );
  }

  function isDebugEnabled() {
    return (
      getConfig().debug === true
    );
  }

  function normalizeString(
    value
  ) {
    return String(
      value || ''
    )
      .trim();
  }

  function normalizeKey(
    value
  ) {
    return normalizeString(
      value
    )
      .toLowerCase()
      .replace(
        /\s+/g,
        '_'
      )
      .replace(
        /-+/g,
        '_'
      )
      .replace(
        /[^a-z0-9_]+/g,
        ''
      );
  }

  function normalizePath(
    value
  ) {
    let path =
      normalizeString(
        value || '/'
      );

    if (!path) {
      return '/';
    }

    if (
      path.length > 1 &&
      path.endsWith('/')
    ) {
      path =
        path.slice(
          0,
          -1
        );
    }

    return path;
  }

  function isElement(
    value
  ) {
    return Boolean(
      value &&
      value.nodeType === 1
    );
  }

  function safeClosest(
    element,
    selector
  ) {
    if (
      !isElement(
        element
      ) ||
      typeof element.closest !==
        'function'
    ) {
      return null;
    }

    try {
      return element.closest(
        selector
      );
    } catch (error) {
      return null;
    }
  }

  /*
   * ------------------------------------------------------------
   * PAGE
   * ------------------------------------------------------------
   */

  function getCurrentPath() {
    return normalizePath(
      window.location &&
      window.location.pathname
        ? window.location.pathname
        : '/'
    );
  }

  function getCurrentUrl() {
    return (
      window.location &&
      window.location.href
        ? window.location.href
        : ''
    );
  }

  /*
   * ------------------------------------------------------------
   * CONTACT TOPIC
   * ------------------------------------------------------------
   */

  function getContactTopic() {
    try {
      const params =
        new URLSearchParams(
          window.location.search ||
          ''
        );

      const rawTopic =
        normalizeString(
          params.get(
            'topic'
          )
        )
          .toLowerCase();

      if (!rawTopic) {
        return '';
      }

      const aliases = {
        signature:
          'marturii',

        marturie:
          'marturii',

        marturii:
          'marturii',

        atelier:
          'atelier',

        wedding:
          'event_planner',

        wedding_planning:
          'event_planner',

        'wedding-planning':
          'event_planner',

        planner:
          'event_planner',

        event_planner:
          'event_planner',

        'event-planner':
          'event_planner',

        'wedding-planner':
          'event_planner',

        colaborare:
          'general',

        collaboration:
          'general',

        altceva:
          'general',

        other:
          'general'
      };

      return (
        aliases[
          rawTopic
        ] ||
        normalizeKey(
          rawTopic
        )
      );
    } catch (error) {
      return '';
    }
  }

  /*
   * ------------------------------------------------------------
   * PAGE SERVICE
   * ------------------------------------------------------------
   */

  function resolvePageService() {
    const config =
      getConfig();

    const pages =
      config.pages ||
      {};

    const currentPath =
      getCurrentPath();

    const pageNames =
      Object.keys(
        pages
      );

    for (
      let index = 0;
      index <
      pageNames.length;
      index += 1
    ) {
      const pageName =
        pageNames[
          index
        ];

      const definition =
        pages[
          pageName
        ] || {};

      const paths =
        Array.isArray(
          definition.paths
        )
          ? definition.paths
          : [];

      const matched =
        paths.some(
          function (
            path
          ) {
            return (
              normalizePath(
                path
              ) ===
              currentPath
            );
          }
        );

      if (matched) {
        return pageName;
      }
    }

    /*
     * Safe Shopify pattern fallbacks.
     * These do not guess custom Bianchi handles.
     */

    if (
      currentPath ===
        '/cart' ||
      currentPath.startsWith(
        '/products/'
      ) ||
      currentPath.startsWith(
        '/collections/'
      ) ||
      currentPath.startsWith(
        '/search'
      )
    ) {
      return 'shop';
    }

    if (
      currentPath.startsWith(
        '/blogs/'
      )
    ) {
      return 'journal';
    }

    return 'general';
  }

  /*
   * ------------------------------------------------------------
   * ELEMENT SERVICE
   * ------------------------------------------------------------
   */

  function getExplicitService(
    element
  ) {
    const serviceElement =
      safeClosest(
        element,
        '[data-ut-service]'
      );

    if (!serviceElement) {
      return '';
    }

    return normalizeKey(
      serviceElement
        .getAttribute(
          'data-ut-service'
        )
    );
  }

  function resolveService(
    element,
    fallback
  ) {
    const explicit =
      getExplicitService(
        element
      );

    if (explicit) {
      return explicit;
    }

    const supplied =
      normalizeKey(
        fallback
      );

    if (supplied) {
      return supplied;
    }

    return resolvePageService();
  }

  /*
   * ------------------------------------------------------------
   * SECTION DETECTION
   * ------------------------------------------------------------
   */

  function getSectionElement(
    element
  ) {
    return (
      safeClosest(
        element,
        '[data-ut-section]'
      ) ||
      safeClosest(
        element,
        '[data-ut-location]'
      ) ||
      safeClosest(
        element,
        '[id]'
      )
    );
  }

  function getSectionName(
    element
  ) {
    const sectionElement =
      getSectionElement(
        element
      );

    if (!sectionElement) {
      return '';
    }

    const explicit =
      normalizeKey(
        sectionElement
          .getAttribute(
            'data-ut-section'
          )
      );

    if (explicit) {
      return explicit;
    }

    const location =
      normalizeKey(
        sectionElement
          .getAttribute(
            'data-ut-location'
          )
      );

    if (location) {
      return location;
    }

    const id =
      normalizeKey(
        sectionElement.id
      );

    if (
      id &&
      (
        id.startsWith(
          'bianchi_'
        ) ||
        id.startsWith(
          'signature_'
        ) ||
        id.startsWith(
          'event_'
        )
      )
    ) {
      return id;
    }

    return '';
  }

  function getClickLocation(
    element
  ) {
    const explicit =
      safeClosest(
        element,
        '[data-ut-location]'
      );

    if (explicit) {
      const value =
        normalizeKey(
          explicit.getAttribute(
            'data-ut-location'
          )
        );

      if (value) {
        return value;
      }
    }

    const section =
      getSectionName(
        element
      );

    if (section) {
      return section;
    }

    return (
      resolvePageService() +
      '_page'
    );
  }

  /*
   * ------------------------------------------------------------
   * LINK
   * ------------------------------------------------------------
   */

  function getLinkElement(
    element
  ) {
    if (
      !isElement(
        element
      )
    ) {
      return null;
    }

    if (
      element.tagName &&
      element.tagName
        .toLowerCase() ===
        'a'
    ) {
      return element;
    }

    return safeClosest(
      element,
      'a'
    );
  }

  function getHref(
    element
  ) {
    const link =
      getLinkElement(
        element
      );

    if (!link) {
      return '';
    }

    return normalizeString(
      link.getAttribute(
        'href'
      )
    );
  }

  function getAbsoluteHref(
    element
  ) {
    const href =
      getHref(
        element
      );

    if (!href) {
      return '';
    }

    try {
      return new URL(
        href,
        window.location.origin
      ).href;
    } catch (error) {
      return '';
    }
  }

  /*
   * ------------------------------------------------------------
   * LINK TYPE
   * ------------------------------------------------------------
   */

  function detectLinkType(
    element
  ) {
    const href =
      getHref(
        element
      );

    if (!href) {
      return 'unknown';
    }

    const lower =
      href.toLowerCase();

    if (
      lower.startsWith(
        'tel:'
      )
    ) {
      return 'phone';
    }

    if (
      lower.startsWith(
        'mailto:'
      )
    ) {
      return 'email';
    }

    if (
      lower.startsWith(
        '#'
      )
    ) {
      return 'anchor';
    }

    if (
      lower.includes(
        'wa.me/'
      ) ||
      lower.includes(
        'whatsapp.com/'
      )
    ) {
      return 'whatsapp';
    }

    try {
      const url =
        new URL(
          href,
          window.location.origin
        );

      if (
        url.origin ===
        window.location.origin
      ) {
        return 'internal';
      }

      return 'external';
    } catch (error) {
      return 'unknown';
    }
  }

  /*
   * ------------------------------------------------------------
   * TARGET RESOLUTION
   * ------------------------------------------------------------
   */

  function resolveTarget(
    element
  ) {
    const type =
      detectLinkType(
        element
      );

    const href =
      getHref(
        element
      );

    if (
      type === 'phone'
    ) {
      return 'phone';
    }

    if (
      type === 'email'
    ) {
      return 'email';
    }

    if (
      type === 'whatsapp'
    ) {
      return 'whatsapp';
    }

    if (
      type === 'anchor'
    ) {
      return normalizeKey(
        href.replace(
          /^#/,
          ''
        )
      ) || 'anchor';
    }

    if (
      type !== 'internal'
    ) {
      return type;
    }

    try {
      const url =
        new URL(
          href,
          window.location.origin
        );

      const path =
        normalizePath(
          url.pathname
        );

      const config =
        getConfig();

      const pages =
        config.pages ||
        {};

      const pageNames =
        Object.keys(
          pages
        );

      for (
        let index = 0;
        index <
        pageNames.length;
        index += 1
      ) {
        const pageName =
          pageNames[
            index
          ];

        const definition =
          pages[
            pageName
          ] || {};

        const paths =
          Array.isArray(
            definition.paths
          )
            ? definition.paths
            : [];

        const matched =
          paths.some(
            function (
              candidate
            ) {
              return (
                normalizePath(
                  candidate
                ) ===
                path
              );
            }
          );

        if (matched) {
          return pageName;
        }
      }

      if (
        path.startsWith(
          '/blogs/'
        )
      ) {
        return 'journal';
      }

      if (
        path ===
          '/cart' ||
        path.startsWith(
          '/products/'
        ) ||
        path.startsWith(
          '/collections/'
        )
      ) {
        return 'shop';
      }

      return 'internal';
    } catch (error) {
      return 'unknown';
    }
  }

  /*
   * ------------------------------------------------------------
   * LABEL
   * ------------------------------------------------------------
   */

  function getElementLabel(
    element
  ) {
    const target =
      getLinkElement(
        element
      ) ||
      element;

    if (
      !isElement(
        target
      )
    ) {
      return '';
    }

    const explicit =
      normalizeString(
        target.getAttribute(
          'data-ut-label'
        )
      );

    if (explicit) {
      return explicit.slice(
        0,
        150
      );
    }

    const aria =
      normalizeString(
        target.getAttribute(
          'aria-label'
        )
      );

    if (aria) {
      return aria.slice(
        0,
        150
      );
    }

    const text =
      normalizeString(
        target.textContent
      )
        .replace(
          /\s+/g,
          ' '
        );

    if (text) {
      return text.slice(
        0,
        150
      );
    }

    const title =
      normalizeString(
        target.getAttribute(
          'title'
        )
      );

    return title.slice(
      0,
      150
    );
  }

  /*
   * ------------------------------------------------------------
   * SOCIAL
   * ------------------------------------------------------------
   */

  function detectSocialPlatform(
    element
  ) {
    const href =
      getAbsoluteHref(
        element
      )
        .toLowerCase();

    if (!href) {
      return '';
    }

    const platforms = [
      {
        name:
          'instagram',
        markers: [
          'instagram.com'
        ]
      },
      {
        name:
          'facebook',
        markers: [
          'facebook.com',
          'fb.com'
        ]
      },
      {
        name:
          'pinterest',
        markers: [
          'pinterest.com',
          'pin.it'
        ]
      },
      {
        name:
          'tiktok',
        markers: [
          'tiktok.com'
        ]
      },
      {
        name:
          'linkedin',
        markers: [
          'linkedin.com'
        ]
      },
      {
        name:
          'youtube',
        markers: [
          'youtube.com',
          'youtu.be'
        ]
      }
    ];

    for (
      let index = 0;
      index <
      platforms.length;
      index += 1
    ) {
      const platform =
        platforms[
          index
        ];

      const match =
        platform.markers.some(
          function (
            marker
          ) {
            return href.includes(
              marker
            );
          }
        );

      if (match) {
        return platform.name;
      }
    }

    return '';
  }

  /*
   * ------------------------------------------------------------
   * ARTICLE SHARE
   * ------------------------------------------------------------
   */

  function isArticleShare(
    element
  ) {
    const config =
      getConfig();

    const selector =
      config.articleShare &&
      config.articleShare
        .containerSelector
        ? config.articleShare
            .containerSelector
        : '';

    if (!selector) {
      return false;
    }

    return Boolean(
      safeClosest(
        element,
        selector
      )
    );
  }

  function detectShareMethod(
    element
  ) {
    if (
      !isArticleShare(
        element
      )
    ) {
      return '';
    }

    const social =
      detectSocialPlatform(
        element
      );

    if (social) {
      return social;
    }

    const type =
      detectLinkType(
        element
      );

    if (
      type === 'email'
    ) {
      return 'email';
    }

    const explicit =
      safeClosest(
        element,
        '[data-share-method]'
      );

    if (explicit) {
      return normalizeKey(
        explicit.getAttribute(
          'data-share-method'
        )
      );
    }

    const label =
      getElementLabel(
        element
      )
        .toLowerCase();

    if (
      label.includes(
        'cop'
      ) ||
      label.includes(
        'link'
      )
    ) {
      return 'copy_link';
    }

    return 'unknown';
  }

  /*
   * ------------------------------------------------------------
   * PHONE / EMAIL CONFIG MATCH
   * ------------------------------------------------------------
   */

  function normalizePhone(
    value
  ) {
    return String(
      value || ''
    )
      .replace(
        /\D+/g,
        ''
      );
  }

  function getPhoneKey(
    element
  ) {
    const href =
      getHref(
        element
      );

    if (
      !href.toLowerCase()
        .startsWith(
          'tel:'
        )
    ) {
      return '';
    }

    const phone =
      normalizePhone(
        href.slice(4)
      );

    const phones =
      getConfig().phones ||
      {};

    const keys =
      Object.keys(
        phones
      );

    for (
      let index = 0;
      index <
      keys.length;
      index += 1
    ) {
      const key =
        keys[index];

      const definition =
        phones[key] ||
        {};

      const normalized =
        Array.isArray(
          definition.normalized
        )
          ? definition.normalized
              .map(
                normalizePhone
              )
          : [];

      if (
        normalized.includes(
          phone
        )
      ) {
        return key;
      }
    }

    return '';
  }

  function getEmailKey(
    element
  ) {
    const href =
      getHref(
        element
      );

    if (
      !href.toLowerCase()
        .startsWith(
          'mailto:'
        )
    ) {
      return '';
    }

    const email =
      href
        .slice(7)
        .split('?')[0]
        .trim()
        .toLowerCase();

    const emails =
      getConfig().emails ||
      {};

    const keys =
      Object.keys(
        emails
      );

    for (
      let index = 0;
      index <
      keys.length;
      index += 1
    ) {
      const key =
        keys[index];

      const definition =
        emails[key] ||
        {};

      const normalized =
        Array.isArray(
          definition.normalized
        )
          ? definition.normalized
              .map(
                function (
                  value
                ) {
                  return String(
                    value || ''
                  )
                    .trim()
                    .toLowerCase();
                }
              )
          : [];

      if (
        normalized.includes(
          email
        )
      ) {
        return key;
      }
    }

    return '';
  }

  /*
   * ------------------------------------------------------------
   * FULL ELEMENT CONTEXT
   * ------------------------------------------------------------
   */

  function inspect(
    element
  ) {
    return {
      page_service:
        resolvePageService(),

      service:
        resolveService(
          element
        ),

      section_name:
        getSectionName(
          element
        ),

      click_location:
        getClickLocation(
          element
        ),

      link_type:
        detectLinkType(
          element
        ),

      target:
        resolveTarget(
          element
        ),

      label:
        getElementLabel(
          element
        ),

      social_platform:
        detectSocialPlatform(
          element
        ),

      article_share:
        isArticleShare(
          element
        ),

      share_method:
        detectShareMethod(
          element
        ),

      phone_key:
        getPhoneKey(
          element
        ),

      email_key:
        getEmailKey(
          element
        ),

      contact_topic:
        getContactTopic()
    };
  }

  /*
   * ------------------------------------------------------------
   * PUBLIC API
   * ------------------------------------------------------------
   */

  window.UnifiedDetection = {
    version:
      VERSION,

    getCurrentPath:
      getCurrentPath,

    getCurrentUrl:
      getCurrentUrl,

    getContactTopic:
      getContactTopic,

    resolvePageService:
      resolvePageService,

    resolveService:
      resolveService,

    getSectionElement:
      getSectionElement,

    getSectionName:
      getSectionName,

    getClickLocation:
      getClickLocation,

    getLinkElement:
      getLinkElement,

    getHref:
      getHref,

    getAbsoluteHref:
      getAbsoluteHref,

    detectLinkType:
      detectLinkType,

    resolveTarget:
      resolveTarget,

    getElementLabel:
      getElementLabel,

    detectSocialPlatform:
      detectSocialPlatform,

    isArticleShare:
      isArticleShare,

    detectShareMethod:
      detectShareMethod,

    getPhoneKey:
      getPhoneKey,

    getEmailKey:
      getEmailKey,

    inspect:
      inspect
  };

  if (
    isDebugEnabled()
  ) {
    console.info(
      '[Unified Detection] Detection initialized',
      {
        version:
          VERSION,

        path:
          getCurrentPath(),

        pageService:
          resolvePageService(),

        contactTopic:
          getContactTopic()
      }
    );
  }
})();